import { Link } from 'react-router-dom';
import { articles as allArticles } from '@/mocks/articles';

export default function HeroSection() {
  const topArticles = allArticles.slice(0, 3);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center bg-background-50 pt-20 pb-16 px-4 md:px-6">
      <div className="w-full max-w-4xl mx-auto text-center mb-10 md:mb-14">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight tracking-tight">
          全网最快
          <br />
          <span className="text-primary-500">明星黑料</span>
          <br />
          吃瓜平台
        </h1>
        <p className="mt-5 text-foreground-600 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          911爆料网 — 吃瓜黑料第一站。网红翻车塌房现场、明星私下猛料每日追踪，不遗漏任何一个网络大瓜。
        </p>
        <div className="mt-8">
          <a
            href="#category-grid"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即开瓜
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>
      </div>

      <div className="relative w-full max-w-5xl mx-auto h-[420px] md:h-[520px]">
        {topArticles.map((article, i) => {
          const isCenter = i === 1;
          const positions = [
            'left-0 md:left-[5%] top-8 md:top-12 z-10 -rotate-3',
            'left-1/2 -translate-x-1/2 top-0 z-20',
            'right-0 md:right-[5%] top-8 md:top-12 z-10 rotate-3',
          ];
          const sizes = [
            'w-[240px] md:w-[300px] h-[320px] md:h-[400px]',
            'w-[260px] md:w-[340px] h-[360px] md:h-[460px]',
            'w-[240px] md:w-[300px] h-[320px] md:h-[400px]',
          ];

          return (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`absolute ${positions[i]} ${sizes[i]} rounded-xl overflow-hidden group transition-all duration-500 hover:z-30 ${
                isCenter ? 'hover:scale-[1.02]' : 'hover:scale-105 hover:rotate-0'
              }`}
            >
              <img
                src={article.imageUrl}
                alt={article.title}
                title={`911爆料网 - ${article.title}`}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                {article.isExclusive && (
                  <span className="inline-block px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-semibold rounded-full mb-2 whitespace-nowrap">
                    独家
                  </span>
                )}
                <h3 className="text-background-50 font-heading font-bold text-sm md:text-base leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-background-50/70 text-xs mt-1.5 line-clamp-1">{article.date} · {article.views.toLocaleString()} 次阅读</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}